import React, { useEffect } from "react";
import './style.css'


const CustomerSupportPage = ({setActivePath}) => {
    useEffect(() => {
        setActivePath("Customer Support");
      }, [setActivePath]);


  return (
    <div className="outlet-container">
Customer support      
    </div>
  )
}

export default CustomerSupportPage
